import { Component, Input, OnInit } from '@angular/core';
import { Flight, Segment } from 'src/main/webapp/assets/models/iter.model';

/**
 * Componente per modellare gli scali di un volo.
 */
@Component({
  selector: 'app-flight-stopover',
  styleUrls: ['./flight-stopover.component.scss'],
  templateUrl: './flight-stopover.component.html'
})
export class FlightStopoverComponent implements OnInit {
  @Input() public flight!: Flight;

  private readonly andataRitorno = 2;
  private readonly scaliDiretto = 1;
  private segments: Segment[] = [];

  public ngOnInit(): void {
    this.segments = this.flight.segments || [];
  }

  public getStopovers(): number {
    return this.segments.length - 1;
  }

  public isDirect(): boolean {
    return this.segments.length === this.scaliDiretto;
  }

  public getIATAScali(): string {
    if (this.segments.length < this.andataRitorno) {
      return '';
    }

    let stops = '';
    for (const [index, value] of this.segments.entries()) {
      if (index === this.segments.length - 1) {
        break;
      }
      stops += `${value.arrival?.iata}, `;
    }

    const caratteriDaEliminare = 2;

    return stops.substr(0, stops.length - caratteriDaEliminare);
  }
}
